'use strict';

/**
 * Component for numbers
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('../../templates/components/field-number.hbs');

var NumberComponent = ItemView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    ui: function(){
        var field = this.getOption('field');

        return {
            'sizeInputNumber': '[name="' + field.name + '"]',
            'selectNumberUnit': 'select[name="' + field.unitField + '"]',
        };
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        unitField: function(){
            var field = this.getOption('field');
            var catalog = this.model.collection.catalog;
            var unitField = catalog.getFieldDefinition(field.unitField);

            return unitField;
        },

        unitEnumValues: function(){
            var field = this.getOption('field');
            var catalog = this.model.collection.catalog;
            var unitField = catalog.getFieldDefinition(field.unitField);

            if (!unitField.options && !unitField.options.enumValues) {
                console.warn('No unit enum values present for number field:', unitField.name);
            }

            return unitField.options.enumValues;
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {
        // var field = this.getOption('field');

        // // Render select weight unit
        // this.renderSelectOptions(
        //     this.ui.selectNumberUnit,
        //     App.BaseModule.weightUnitsCollection,
        //     'key',
        //     'key',
        //     function(option) {
        //         return this.model && this.model.get(field.unitField) == option.value;
        //     }.bind(this)
        // );
    },

    onShow: function() {
        this.reset();
    },

    getData: function() {
        var data = {};
        var catalog = this.model.collection.catalog;
        var field = this.getOption('field');
        var unitField = catalog.getFieldDefinition(field.unitField);

        var value = this.ui.sizeInputNumber.val().trim();
        var numberUnit = this.ui.selectNumberUnit.length ? this.ui.selectNumberUnit.val().trim() : unitField.defaultValue;

        data[field.name] = value;
        data[field.unitField] = numberUnit;

        return data;
    },
});

module.exports = NumberComponent;